/* StylinArts – Colette v5.0 (Luxury Private Styling Interface) */
(function () {
  if (window.__SA_V2_WIDGET__) return;
  window.__SA_V2_WIDGET__ = true;

  var OPTS = Object.assign({
    label: 'Colette',
    hintLimit: 8,
    safeBottom: 8,
    endpoint: 'https://www.stylinarts.com/_ai/chat'
  }, (window.SA_STYLIST_OPTS || {}));

  var ORIGIN;
  try { ORIGIN = new URL(OPTS.endpoint).origin; } catch(e){ ORIGIN = 'https://www.stylinarts.com'; }
  var API_CHAT = OPTS.endpoint;
  var API_IMG  = ORIGIN + '/_ai/image_search';

  var EXISTING_STYLE = document.getElementById('colette-v5-style');
  if (EXISTING_STYLE) EXISTING_STYLE.remove();

  var CSS = `
  :root{
    --clt-safe:${Number(OPTS.safeBottom)}px;
    --clt-star:#C7AD82;
    --clt-star-dark:#C2A77D;
    --clt-ink:#171717;
    --clt-muted:#7b7268;
    --clt-line:rgba(33,24,14,.08);
    --clt-paper:rgba(248,244,238,.96);
    --clt-paper-2:rgba(255,255,255,.70);
  }

  /* =========================
     Launcher
  ========================= */
  .clt-pill{
    position:fixed;
    z-index:2147483000;
    right:clamp(18px,2.6vw,26px);
    bottom:calc(env(safe-area-inset-bottom,0px) + var(--clt-safe));
    display:inline-flex;
    align-items:center;
    justify-content:center;
    gap:0;
    height:38px;
    min-height:38px;
    padding:0 14px 0 11px;
    border-radius:999px;
    background:rgba(255,255,255,.88);
    color:var(--clt-ink);
    font:500 12.5px/1 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:.005em;
    cursor:pointer;
    user-select:none;
    touch-action:none;
    border:1px solid rgba(17,17,17,.06);
    box-shadow:
      0 4px 12px rgba(0,0,0,.06),
      0 1px 0 rgba(255,255,255,.6) inset;
    isolation:isolate;
    transform:translateZ(0);
    -webkit-backdrop-filter: blur(6px) saturate(1.02);
    backdrop-filter: blur(6px) saturate(1.02);
    transition:
      box-shadow .18s ease,
      background-color .18s ease,
      transform .18s ease,
      border-color .18s ease;
  }

  .clt-pill::before{
    content:"";
    position:absolute;
    inset:0;
    border-radius:inherit;
    pointer-events:none;
    background:linear-gradient(180deg, rgba(255,255,255,.22), rgba(255,255,255,.04));
    z-index:-1;
  }

  .clt-pill:hover{
    background:rgba(255,255,255,.94);
    border-color:rgba(17,17,17,.08);
    box-shadow:0 6px 18px rgba(0,0,0,.10);
    color:var(--clt-ink) !important;
  }

  .clt-pill:active{ transform:translateZ(0) scale(.99); }

  .clt-pill:focus-visible{
    outline:2px solid rgba(0,0,0,.72);
    outline-offset:2px;
    box-shadow:0 0 0 4px rgba(0,0,0,.08), 0 6px 18px rgba(0,0,0,.10);
  }

  .clt-pill__spark{
    position:relative;
    width:14px;
    height:14px;
    flex:0 0 14px;
    margin-right:5px;
  }

  .clt-pill__star{
    position:absolute;
    inset:0;
    display:inline-flex;
    align-items:center;
    justify-content:center;
    color:var(--clt-star);
    opacity:.95;
    width:16px;
    height:16px;
    top:.5px;
    left:0;
  }

  .clt-pill__star svg{
    width:100%;
    height:100%;
    display:block;
  }

  .clt-pill__label{
    padding-left:0;
    white-space:nowrap;
  }

  @media (prefers-reduced-motion:no-preference){
    .clt-pill__star{
      animation: cltShimmer 3.6s ease-in-out infinite;
    }
    @keyframes cltShimmer{
      0%,100%{ transform:rotate(-4deg) scale(1); opacity:.9; }
      50%{ transform:rotate(-1deg) scale(1.035); opacity:1; }
    }
  }

  /* =========================
     Panel
  ========================= */
  .clt-panel{
    position:fixed;
    z-index:2147482999;
    right:clamp(16px,2.6vw,26px);
    bottom:calc(env(safe-area-inset-bottom,0px) + var(--clt-safe) + 54px);
    width:min(420px, 92vw);
    background:var(--clt-paper);
    -webkit-backdrop-filter: blur(12px) saturate(1.02);
    backdrop-filter: blur(12px) saturate(1.02);
    border:1px solid rgba(33,24,14,.08);
    border-radius:22px;
    overflow:hidden;
    box-shadow:
      0 24px 60px rgba(0,0,0,.16),
      0 1px 0 rgba(255,255,255,.7) inset;
    font:14px/1.45 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    color:var(--clt-ink);
    display:none;
  }

  .clt-head{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:14px;
    padding:20px 20px 14px;
    border-bottom:1px solid rgba(33,24,14,.07);
    background:linear-gradient(180deg, rgba(255,255,255,.30), rgba(255,255,255,0));
  }

  .clt-head__title-wrap{
    min-width:0;
    flex:1 1 auto;
  }

  .clt-head__title{
    margin:0;
    font:600 34px/1.02 Georgia, "Times New Roman", serif;
    letter-spacing:-.02em;
    color:#161616;
  }

  .clt-head__meta{
    margin-top:6px;
    font:500 12px/1.35 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    color:var(--clt-muted);
  }

  .clt-head__actions{
    display:flex;
    align-items:center;
    gap:14px;
    flex:0 0 auto;
    padding-top:4px;
  }

  .clt-head__btn{
    all:unset;
    color:var(--clt-muted);
    font:500 12px/1 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:.01em;
    cursor:pointer;
  }

  .clt-head__btn:hover{
    color:var(--clt-ink);
  }

  .clt-body{
    max-height:min(60vh, 500px);
    overflow:auto;
    padding:16px 20px 10px;
  }

  .clt-section{
    margin:0 0 18px;
    width:100%;
  }

  .clt-section:last-child{
    margin-bottom:0;
  }

  .clt-label{
    margin:0 0 12px;
    font:500 11px/1.3 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:.08em;
    text-transform:uppercase;
    color:#8d8479;
  }

  /* Explore cards */
  .clt-explore{
    display:grid;
    grid-template-columns:minmax(0, 1fr);
    gap:10px;
    width:100%;
  }

  .clt-explore__item{
    all:unset;
    box-sizing:border-box;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    justify-content:flex-start;
    width:100%;
    min-width:0;
    max-width:100%;
    padding:14px 14px 13px;
    margin:0;
    border:1px solid rgba(33,24,14,.08);
    background:rgba(255,255,255,.58);
    border-radius:16px;
    cursor:pointer;
    box-shadow:0 1px 2px rgba(0,0,0,.02);
    transition:border-color .15s ease, background-color .15s ease, transform .15s ease, box-shadow .15s ease;
  }

  .clt-explore__item:hover{
    background:rgba(255,255,255,.78);
    border-color:rgba(33,24,14,.12);
    box-shadow:0 6px 16px rgba(0,0,0,.05);
    transform:translateY(-1px);
  }

  .clt-explore__kicker{
    display:block;
    width:100%;
    margin:0 0 6px;
    font:500 10px/1.1 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:.08em;
    text-transform:uppercase;
    color:#9a9186;
  }

  .clt-explore__title{
    display:block;
    width:100%;
    margin:0;
    font:600 17px/1.15 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:-.01em;
    color:#171717;
  }

  .clt-explore__sub{
    display:block;
    width:100%;
    margin-top:7px;
    font:400 13px/1.4 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    color:#7b7268;
  }

  /* Notes / answers */
  .clt-note{
    background:rgba(255,255,255,.42);
    border:1px solid rgba(33,24,14,.06);
    border-radius:16px;
    padding:14px 14px 13px;
    color:#171717;
  }

  .clt-note p{
    margin:0 0 9px;
  }

  .clt-note p:last-child{
    margin-bottom:0;
  }

  .clt-note ul{
    margin:10px 0 0 18px;
    padding-left:18px;
    list-style:disc;
    list-style-position:outside;
  }

  .clt-note li{
    margin:4px 0;
  }

  /* Product result cards */
  .clt-results{
    display:grid;
    grid-template-columns:minmax(0, 1fr);
    gap:10px;
    width:100%;
  }

  .clt-result{
    box-sizing:border-box;
    width:100%;
    min-width:0;
    border:1px solid rgba(33,24,14,.08);
    border-radius:16px;
    padding:10px;
    display:flex;
    align-items:flex-start;
    gap:10px;
    text-decoration:none;
    color:inherit;
    background:rgba(255,255,255,.58);
    transition:border-color .15s ease, background-color .15s ease, transform .15s ease, box-shadow .15s ease;
  }

  .clt-result:hover{
    background:rgba(255,255,255,.78);
    border-color:rgba(33,24,14,.12);
    box-shadow:0 6px 16px rgba(0,0,0,.05);
    transform:translateY(-1px);
  }

  .clt-result__image{
    width:72px;
    height:72px;
    object-fit:cover;
    border-radius:12px;
    border:1px solid rgba(33,24,14,.06);
    flex:0 0 72px;
  }

  .clt-result__copy{
    min-width:0;
    flex:1 1 auto;
  }

  .clt-result__title{
    font-weight:600;
    font-size:12.5px;
    line-height:1.32;
    color:#171717;
    word-break:break-word;
  }

  .clt-result__meta{
    font-size:11px;
    color:#7b7268;
    margin-top:5px;
  }

  /* Input */
  .clt-input{
    display:flex;
    gap:8px;
    align-items:center;
    border-top:1px solid rgba(33,24,14,.07);
    padding:14px 20px 18px;
    background:rgba(255,255,255,.42);
  }

  .clt-input__field{
    flex:1;
    height:46px;
    border:1px solid rgba(33,24,14,.10);
    border-radius:14px;
    padding:0 14px;
    font:14px/46px ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    background:rgba(255,255,255,.76);
    color:#171717;
    box-shadow:inset 0 1px 2px rgba(0,0,0,.02);
  }

  .clt-input__field::placeholder{
    color:#93897d;
  }

  .clt-input__send{
    all:unset;
    box-sizing:border-box;
    height:46px;
    border-radius:14px;
    padding:0 18px;
    font:600 14px/46px ui-sans-serif, system-ui;
    cursor:pointer;
    color:#fff;
    background:#131313;
    box-shadow:0 8px 20px rgba(0,0,0,.16);
    transition:transform .15s ease, box-shadow .15s ease, background-color .15s ease;
  }

  .clt-input__send:hover{
    transform:translateY(-1px);
    box-shadow:0 10px 24px rgba(0,0,0,.18);
    background:#0f0f0f;
  }

  .clt-input__send:active{
    transform:translateY(0);
  }

  .clt-input__send:focus-visible{
    outline:2px solid rgba(0,0,0,.75);
    outline-offset:2px;
  }

  @media (max-width: 768px){
    .clt-panel{
      right:10px;
      bottom:calc(env(safe-area-inset-bottom,0px) + 46px);
      width:min(94vw, 420px);
      border-radius:20px;
    }

    .clt-head{
      padding:18px 16px 12px;
    }

    .clt-head__title{
      font-size:30px;
    }

    .clt-head__meta{
      font-size:11px;
    }

    .clt-body{
      padding:14px 16px 8px;
    }

    .clt-explore{
      gap:9px;
    }

    .clt-explore__item{
      padding:13px 13px 12px;
    }

    .clt-explore__title{
      font-size:16px;
    }

    .clt-explore__sub{
      font-size:12.5px;
    }

    .clt-input{
      padding:12px 16px 16px;
    }
  }

  @media (prefers-color-scheme: dark){
    .clt-panel{
      background:rgba(24,24,24,.92);
      border:1px solid rgba(255,255,255,.10);
      box-shadow:0 18px 50px rgba(0,0,0,.32);
      color:#f4f4f2;
    }

    .clt-head,
    .clt-input{
      border-color:rgba(255,255,255,.08);
    }

    .clt-head__title,
    .clt-note,
    .clt-result__title,
    .clt-explore__title{
      color:#f4f4f2;
    }

    .clt-head__meta,
    .clt-label,
    .clt-result__meta,
    .clt-explore__kicker,
    .clt-explore__sub{
      color:#b7b7b7;
    }

    .clt-head__btn{
      color:#b7b7b7;
    }

    .clt-head__btn:hover{
      color:#f4f4f2;
    }

    .clt-note,
    .clt-result,
    .clt-explore__item{
      background:rgba(255,255,255,.04);
      border-color:rgba(255,255,255,.08);
    }

    .clt-input{
      background:rgba(255,255,255,.03);
    }

    .clt-input__field{
      background:rgba(255,255,255,.04);
      border-color:rgba(255,255,255,.09);
      color:#f4f4f2;
    }

    .clt-input__field::placeholder{
      color:#b7b7b7;
    }
  }
  `;

  var style = document.createElement('style');
  style.id = 'colette-v5-style';
  style.textContent = CSS;
  document.head.appendChild(style);

  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function renderAI(text){
    text = String(text || '').replace(/\r\n/g, '\n');
    text = text.replace(/\s+(•|-|\*)\s+/g, '\n• ');
    var lines = text.split('\n');
    var blocks = [];
    var bullets = [];

    function flush(){
      if(!bullets.length) return;
      blocks.push('<ul>'+bullets.map(function(b){
        return '<li>'+esc(b.replace(/^(•|-|\*)\s+/,'').trim())+'</li>';
      }).join('')+'</ul>');
      bullets = [];
    }

    for (var i=0;i<lines.length;i++){
      var ln = lines[i].trim();
      if (!ln){ flush(); continue; }
      if (/^(•|-|\*)\s+/.test(ln)){ bullets.push(ln); continue; }
      flush();
      blocks.push('<p>'+esc(ln)+'</p>');
    }

    flush();
    return blocks.join('');
  }

  function mount(){
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'clt-pill';
    pill.innerHTML =
      '<span class="clt-pill__spark">'+
        '<span class="clt-pill__star" aria-hidden="true"></span>'+
      '</span>'+
      '<span class="clt-pill__label"></span>';

    document.body.appendChild(pill);

    function setLauncherLabel(){
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      pill.querySelector('.clt-pill__label').textContent = isMobile ? 'Colette' : 'Ask Colette';
    }

    setLauncherLabel();
    window.addEventListener('resize', setLauncherLabel);

    pill.querySelectorAll('.clt-pill__star').forEach(function(el){
      el.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path fill="currentColor" d="M12 3.2l1.15 3.65 3.65 1.15-3.65 1.15L12 13.8l-1.15-3.65-3.65-1.15 3.65-1.15L12 3.2z"/>' +
        '</svg>';
    });

    var panel = document.createElement('div');
    panel.className = 'clt-panel';
    panel.style.display = 'none';
    panel.innerHTML = [
      '<div class="clt-head">',
        '<div class="clt-head__title-wrap">',
          '<div class="clt-head__title">Colette</div>',
          '<div class="clt-head__meta">Private styling, quietly tailored to you.</div>',
        '</div>',
        '<div class="clt-head__actions">',
          '<button type="button" class="clt-head__btn" data-clt-action="visual" title="Find similar">Visual</button>',
          '<button type="button" class="clt-head__btn" data-clt-action="close" title="Close">Close</button>',
        '</div>',
      '</div>',
      '<div class="clt-body"></div>',
      '<div class="clt-input">',
        '<input class="clt-input__field" placeholder="Ask for a color, price, size, policy..."/>',
        '<button class="clt-input__send">Send</button>',
      '</div>'
    ].join('');
    document.body.appendChild(panel);

    var body = panel.querySelector('.clt-body');
    var input = panel.querySelector('.clt-input__field');
    var sendBtn = panel.querySelector('.clt-input__send');

    function row(html){
      body.insertAdjacentHTML('beforeend', '<div class="clt-section"><div class="clt-note">'+html+'</div></div>');
      body.scrollTop = body.scrollHeight;
    }

    function resultCards(hints){
      return (hints || []).slice(0, Number(OPTS.hintLimit || 8)).map(function(h){
        return '<a class="clt-result" href="'+(h.url || '#')+'">'+
                 (h.image ? '<img class="clt-result__image" loading="lazy" src="'+h.image+'" alt=""/>' : '')+
                 '<div class="clt-result__copy">'+
                   '<div class="clt-result__title">'+esc(h.label || '')+'</div>'+
                   '<div class="clt-result__meta">'+esc(h.price || '')+(h.available ? ' • In stock' : '')+'</div>'+
                 '</div>'+
               '</a>';
      }).join('');
    }

    function renderExplore(){
var qs = [
  { kicker: 'Bodysuits', title: 'Find me a red bodysuit', sub: 'Explore bold, flattering styles in red.' },
  { kicker: 'Price', title: 'Show me red lingerie under $30', sub: 'See affordable red styles without losing the look.' },
  { kicker: 'Fit', title: 'Help me choose my size', sub: 'Find the right fit with more confidence.' },
  { kicker: 'Returns', title: 'What can I return?', sub: 'Understand returns before you order.' }
];

      body.insertAdjacentHTML(
        'beforeend',
        '<div class="clt-section" data-clt-explore-row>' +
          '<div class="clt-label">Explore</div>' +
          '<div class="clt-explore">' +
            qs.map(function(q){
              return '<button type="button" class="clt-explore__item" data-clt-query="'+esc(q.title)+'">' +
                       '<span class="clt-explore__kicker">'+esc(q.kicker)+'</span>' +
                       '<span class="clt-explore__title">'+esc(q.title)+'</span>' +
                       '<span class="clt-explore__sub">'+esc(q.sub)+'</span>' +
                     '</button>';
            }).join('') +
          '</div>' +
        '</div>'
      );
    }

    renderExplore();

    function hideExplore(){
      var row = body.querySelector('[data-clt-explore-row]');
      if (row) row.style.display = 'none';
    }

    function openPanel(){
      panel.style.display = 'block';
      setTimeout(function(){ body.scrollTop = body.scrollHeight; }, 0);
    }

    function closePanel(){
      panel.style.display = 'none';
    }

    pill.addEventListener('click', function(){
      panel.style.display === 'none' ? openPanel() : closePanel();
    });

    panel.addEventListener('click', function(e){
      var actionBtn = e.target.closest('[data-clt-action]');
      if (actionBtn){
        var action = actionBtn.getAttribute('data-clt-action');
        if (action === 'close') closePanel();
        if (action === 'visual') findSimilar();
        return;
      }

      var queryBtn = e.target.closest('[data-clt-query]');
      if (queryBtn){
        var q = queryBtn.getAttribute('data-clt-query');
        if (q) send(q);
      }
    });

    (function(){
      var drag=false, ox=0, oy=0, raf=null;

      function clamp(v,min,max){ return Math.max(min,Math.min(max,v)); }
      function setPos(x,y){
        pill.style.left = x+'px';
        pill.style.top = y+'px';
        pill.style.right = '';
        pill.style.bottom = '';
      }

      function down(cx,cy){
        drag=true;
        var r=pill.getBoundingClientRect();
        ox=cx-r.left;
        oy=cy-r.top;
        addEventListener('mousemove',move);
        addEventListener('mouseup',up);
        addEventListener('touchmove',tm,{passive:false});
        addEventListener('touchend',up);
      }

      function q(cx,cy){
        if(raf) return;
        raf=requestAnimationFrame(function(){
          raf=null;
          var w=pill.offsetWidth,h=pill.offsetHeight;
          var bottomPx = 8 + Number(OPTS.safeBottom || 8);
          var x=clamp(cx-ox,8,innerWidth-w-8);
          var y=clamp(cy-oy,8,innerHeight-h-bottomPx);
          setPos(x,y);
        });
      }

      function move(e){ e.preventDefault(); q(e.clientX,e.clientY); }
      function tm(e){ if(!drag) return; e.preventDefault(); var t=e.touches[0]; q(t.clientX,t.clientY); }
      function up(){
        drag=false;
        removeEventListener('mousemove',move);
        removeEventListener('mouseup',up);
        removeEventListener('touchmove',tm);
        removeEventListener('touchend',up);
      }

      pill.addEventListener('mousedown',function(e){ down(e.clientX,e.clientY); });
      pill.addEventListener('touchstart',function(e){
        if(e.touches && e.touches[0]) down(e.touches[0].clientX,e.touches[0].clientY);
      },{passive:true});
    })();

    input.addEventListener('input', function(){
      if (this.value.trim().length) hideExplore();
    });

    function pageCtx(){
      var p={page:'home'};
      try{
        var path=location.pathname;
        if(/\/products\//.test(path)){
          var t=(document.querySelector('h1')||{}).textContent||'';
          t=t.trim();
          var imgEl=document.querySelector('img[src*="cdn.shopify.com"], img[src*="/cdn/shop/"]');
          var imgSrc=imgEl ? (imgEl.currentSrc || imgEl.src) : '';
          p.page='product';
          p.product={title:t,image:imgSrc};
        }else if(/\/collections\//.test(path)){
          var tt=(document.querySelector('h1')||{}).textContent||'';
          tt=tt.trim();
          p.page='collection';
          p.collection={title:tt,handle:path.split('/').pop()};
        }else if(/\/search/.test(path)){
          var q=new URL(location.href).searchParams.get('q')||'';
          p.page='search';
          p.searchQuery=q;
        }else if(/\/cart/.test(path)){
          p.page='cart';
        }
      }catch(e){}
      return p;
    }

    var context = pageCtx();
    var inFlight=false, lastTs=0;

    function guard(){
      var now=Date.now();
      if(inFlight || (now-lastTs)<400) return false;
      lastTs=now;
      return true;
    }

    async function send(qText){
      if (!guard()) return;
      inFlight=true;

      try{
        if (!qText) qText = (input && input.value || '').trim();
        if (input) input.value='';
        if (!qText) return;

        hideExplore();
        row('<p><em>Thinking…</em></p>');

        const res = await fetch(API_CHAT,{
          method:'POST',
          headers:{'content-type':'application/json'},
          body: JSON.stringify({ message:qText, context:context, max_hints:Number(OPTS.hintLimit || 8) })
        });

        const js = await res.json().catch(function(){ return {}; });
        if (body.lastElementChild) body.lastElementChild.remove();

        if (js && js.text) row(renderAI(js.text));

        if (js && Array.isArray(js.hints) && js.hints.length){
          body.insertAdjacentHTML('beforeend','<div class="clt-section"><div class="clt-results">'+resultCards(js.hints)+'</div></div>');
          body.scrollTop = body.scrollHeight;
        }

        if (js && js.error === 'budget_exceeded'){
          row('<p style="color:#b00">Daily AI budget reached. Please try again tomorrow.</p>');
        } else if (js && js.ok===false && js.error){
          row('<p style="color:#b00">'+esc(js.error)+'</p>');
        } else if (!js || (!js.text && !js.hints)){
          row('<p style="color:#b00">Sorry, something went wrong.</p>');
        }
      }catch(e){
        row('<p style="color:#b00">Network issue. Try again.</p>');
      }finally{
        inFlight=false;
      }
    }

    async function findSimilar(){
      if (!guard()) return;
      inFlight=true;

      try{
        var img = (context && context.product && context.product.image) || '';
        if (!img){
          row('<p style="color:#b00">No product image found on this page.</p>');
          return;
        }

        var u = new URL(img, location.href);
        if (!u.searchParams.get('width')) u.searchParams.set('width','768');

        hideExplore();
        row('<p><em>Searching visually…</em></p>');

        const res = await fetch(API_IMG, {
          method:'POST',
          headers:{'content-type':'application/json'},
          body: JSON.stringify({ image_url: u.toString(), topK: Number(OPTS.hintLimit || 8) })
        });

        const js = await res.json().catch(function(){ return {}; });
        if (body.lastElementChild) body.lastElementChild.remove();

        if (js && js.ok && Array.isArray(js.hints) && js.hints.length){
          row('<p><strong>Visual matches</strong></p>');
          body.insertAdjacentHTML('beforeend','<div class="clt-section"><div class="clt-results">'+resultCards(js.hints)+'</div></div>');
        } else if (js && js.error === 'budget_exceeded'){
          row('<p style="color:#b00">Daily AI budget reached. Please try again tomorrow.</p>');
        } else {
          row('<p style="color:#b00">Couldn’t find similar from the image.</p>');
        }
      }catch(e){
        row('<p style="color:#b00">Network issue. Try again.</p>');
      }finally{
        inFlight=false;
      }
    }

    sendBtn.addEventListener('click', function(){ send(); });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter') send();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, {once:true});
  } else {
    mount();
  }
})();